interface PaginationProps {
  current: number;
  total: number;
  onChange: (page: number) => void;
}

export default function Pagination({ current, total, onChange }: PaginationProps) {
  if (total <= 1) return null;

  const pages: number[] = [];
  for (let i = 1; i <= total; i += 1) {
    if (i === 1 || i === total || (i >= current - 1 && i <= current + 1)) {
      pages.push(i);
    }
  }

  const items: (number | string)[] = [];
  let prev = 0;
  pages.forEach((p) => {
    if (prev && p - prev > 1) items.push(`gap-${p}`);
    items.push(p);
    prev = p;
  });

  const baseBtn =
    'min-w-[38px] h-9 px-3 flex items-center justify-center rounded-md text-sm border transition-colors';

  return (
    <nav className="flex items-center justify-center flex-wrap gap-2 mt-8" aria-label="分页导航">
      <button
        type="button"
        onClick={() => onChange(current - 1)}
        disabled={current === 1}
        className={`${baseBtn} border-background-200/70 text-foreground-700 hover:border-accent-500 hover:text-accent-500 disabled:opacity-40 disabled:cursor-not-allowed`}
      >
        <i className="ri-arrow-left-s-line text-base" />
        <span className="ml-1 hidden sm:inline">上一页</span>
      </button>

      {items.map((item) =>
        typeof item === 'string' ? (
          <span key={item} className="px-1 text-foreground-500">…</span>
        ) : (
          <button
            key={item}
            type="button"
            onClick={() => onChange(item)}
            className={`${baseBtn} ${
              item === current
                ? 'bg-accent-500 border-accent-500 text-background-50 font-semibold'
                : 'border-background-200/70 text-foreground-700 hover:border-accent-500 hover:text-accent-500'
            }`}
          >
            {item}
          </button>
        ),
      )}

      <button
        type="button"
        onClick={() => onChange(current + 1)}
        disabled={current === total}
        className={`${baseBtn} border-background-200/70 text-foreground-700 hover:border-accent-500 hover:text-accent-500 disabled:opacity-40 disabled:cursor-not-allowed`}
      >
        <span className="mr-1 hidden sm:inline">下一页</span>
        <i className="ri-arrow-right-s-line text-base" />
      </button>
    </nav>
  );
}